import { ArrowRight } from "lucide-react";

export default function BetaBanner({ onGetIt }) {
  return (
    <div
      className="w-full z-[60] relative overflow-hidden"
      style={{ background: "#0A0C10", borderBottom: "1px solid rgba(59,158,255,0.15)" }}
    >
      {/* Subtle center radial glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: "radial-gradient(ellipse 60% 100% at 50% 50%, rgba(59,158,255,0.07) 0%, transparent 100%)",
        }}
      />

      {/* Animated shimmer sweep */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: "linear-gradient(105deg, transparent 40%, rgba(59,158,255,0.06) 50%, transparent 60%)",
          animation: "banner-shimmer 4s ease-in-out infinite",
        }}
      />

      {/* Glowing bottom border line */}
      <div
        className="absolute bottom-0 left-0 right-0 h-px pointer-events-none"
        style={{
          background: "linear-gradient(90deg, transparent 0%, rgba(59,158,255,0.5) 25%, rgba(96,189,255,0.8) 50%, rgba(59,158,255,0.5) 75%, transparent 100%)",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-4 py-3 flex items-center justify-center gap-4">

        {/* LIVE pill */}
        <div className="flex items-center gap-1.5 flex-shrink-0 rounded-full px-3 py-1"
          style={{ background: "rgba(59,158,255,0.12)", border: "1px solid rgba(59,158,255,0.3)" }}>
          <span className="relative flex h-1.5 w-1.5 flex-shrink-0">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#3B9EFF] opacity-70" />
            <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-[#3B9EFF]" />
          </span>
          <span className="text-[9px] font-black uppercase tracking-[0.2em] text-[#3B9EFF]">Live</span>
        </div>

        {/* Divider */}
        <div className="hidden sm:block w-px h-3.5 bg-white/10 flex-shrink-0" />

        {/* Message */}
        <p className="text-[11px] sm:text-[13px] text-white/60 font-outfit tracking-wide text-center leading-none">
          <span className="text-white font-semibold">Fanible Pre-Registration</span>
          <span className="text-white/30 mx-2">·</span>
          <span className="text-[#3B9EFF] font-medium">Now open</span>
          <span className="hidden sm:inline text-white/40"> on</span>
          <span className="hidden sm:inline text-white/60 font-medium"> Google Play Store</span>
        </p>

        {/* Divider */}
        <div className="hidden sm:block w-px h-3.5 bg-white/10 flex-shrink-0" />

        {/* CTA */}
        <button
          onClick={onGetIt}
          className="hidden sm:flex items-center gap-1.5 flex-shrink-0 group cursor-pointer bg-transparent border-none p-0"
        >
          <span className="text-[11px] font-semibold text-white/40 group-hover:text-white transition-colors duration-200 tracking-wide">
            Pre-Register
          </span>
          <ArrowRight
            size={11}
            className="text-white/30 group-hover:text-[#3B9EFF] group-hover:translate-x-0.5 transition-all duration-200"
          />
        </button>
      </div>

      <style>{`
        @keyframes banner-shimmer {
          0%   { transform: translateX(-100%); }
          60%  { transform: translateX(100%); }
          100% { transform: translateX(100%); }
        }
      `}</style>
    </div>
  );
}
